var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"home"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content_text)}},[_vm._v(_vm._s(_vm.content_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }